import React from "react";
import './css/ContactStyle.css';

function Contact (){
  return (
        <section className="py-5">
          <div className="container text-center">
            <div className="divider"></div>
            <h2 className="section-title">Our Global Office <span>Locations</span></h2>
            <p className="text-muted mb-5">Enim lobortis scelerisque Consectetur erat nam magna etiam tempor orci. Sem et tortor consequat id. Fermentum egestas tellus. Nunc eu hendrerit turpis. Fusce non lectus sem In pellentesque nunc.</p>
            <div className="row g-4">
              <div className="col-md-4">
                <div className="location-card text-start">
                  <h5>USA</h5>
                  <hr />
                  <p><i className="fa fa-map-marker-alt"></i> NO: 58 A, East Madison Street, Baltimore, MD, USA 4508</p>
                  <p><i className="fa fa-phone"></i> 000-123-456789</p>
                  <p><i className="fa fa-envelope"></i> info@example.com</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="location-card text-start">
                  <h5>Spain</h5>
                  <hr />
                  <p><i className="fa fa-map-marker-alt"></i> Calle del Codo, 2, New St, Murcia, 30880, Spain</p>
                  <p><i className="fa fa-phone"></i> 000 123 456789</p>
                  <p><i className="fa fa-envelope"></i> contact@example.com</p>
                </div>
              </div>
              <div className="col-md-4">
                <div className="location-card text-start">
                  <h5>France</h5>
                  <hr />
                  <p><i className="fa fa-map-marker-alt"></i> 96 Rue Oberkampf Street, Paris, France, 75011</p>
                  <p><i className="fa fa-phone"></i> 0000 123 456789</p>
                  <p><i className="fa fa-envelope"></i> support@example.com</p>
                </div>
              </div>
            </div>
          </div>
        </section>
    )
}
export default Contact;